<script lang="ts">
  import { controlContext } from "@kontextwerk/control-web-frame/shared/logic/authentication"
  import { useContextRootClient } from "@kontextwerk/control-web-frame/shared/logic/context-runtime"
  import type { OrgaViewFrameContext } from "../../../../context"
  import ContextPlanning from "./_modules/context-planning"

  const { viewFrameContext } = $props<{ viewFrameContext: OrgaViewFrameContext }>()
  const client = useContextRootClient()
  const session = $derived($controlContext?.session ?? null)
  const organizationId = $derived(
    viewFrameContext.organization?.id ?? viewFrameContext.organizationId ?? null,
  )
</script>

<!-- One bound editor per confirmed context and organization; a switch remounts it. -->
{#if session && organizationId}
  {#key `${session.session_id}:${session.context_revision}:${organizationId}`}
    <ContextPlanning {client} {session} {organizationId} />
  {/key}
{:else}
  <p role="status">Termineinstellungen werden geladen.</p>
{/if}
